import * as zExt from "@redotech/rpc/ext";
import * as z from "zod/v4";

export const getPpuSplitAiAnalysis = {
  name: "getPpuSplitAiAnalysis" as const,
  input: z.object({
    splitId: zExt.objectId(),
    ignoreCache: z.boolean().optional(),
  }),
  output: z.object({
    analysis: z.string().optional(),
    lastUpdatedAt: zExt.instant().optional(),
  }),
};
